import React from "react";
import { Link } from "react-router-dom";

import "../../styles/About/About.scss";

const About = () => {

  return (
    <>
      <div className="about" id="about">
        <div className="about__container">
          <div className="about__header" id="about__heading">
            <h1 data-aos="fade-down" data-aos-delay="0" data-aos-offset="20">
              <span
                data-aos="fade-down"
                data-aos-delay="0"
                data-aos-offset="200"
              >
                A
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-offset="200"
              >
                B
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="400"
                data-aos-offset="200"
              >
                O
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="600"
                data-aos-offset="200"
              >
                U
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="800"
                data-aos-offset="200"
              >
                T
              </span>
              <span
                data-aos="fade-down"
                data-aos-delay="1000"
                data-aos-offset="200"
              >
                .
              </span>
            </h1>
            <p></p>
          </div>

          <div className="about__details-container">
            <div
              className="about__details"
              data-aos="fade-down"
              data-aos-offset="0"
              data-aos-delay="0"
              data-aos-once="true"
            >
              <Link to="/about/intro">
                <h1>
                  0<span>1</span>
                </h1>
                <h2>
                  H<span>ello,</span>
                </h2>
                <p>
                  I am <span>Ajay kumar.</span> <br /> Highly passoinate and
                  enthusiast MERN-Stack with multiple projects.Skilled in
                  developing highly responsive websites and mobile apps with
                  elegant and efficient code.
                </p>
              </Link>
            </div>
            <div
              className="about__details"
              data-aos="fade-down"
              data-aos-offset="-180"
              data-aos-delay="200"
              data-aos-once="true"
            >
              <Link to="/about/experience">
                <h1>
                  0<span>2</span>
                </h1>
                <h2>
                  E<span>xperience</span>
                </h2>
                <p>
                  <span>Worked on many personal projects</span>
                  <br />I have experience in developing highly
                  responsive MERN Stack websites. Skilled in
                  developing highly responsive websites and mobile apps with
                  elegant and efficient code, with a decent knowledge of 
                  DATA STRUCTURE AND ALGORITHM
                  (Problem solving skill.)
                </p>
              </Link>
            </div>
            <div
              className="about__details"
              data-aos="fade-down"
              data-aos-offset="50"
              data-aos-delay="500"
              data-aos-once="true"
            >
              <Link to="/about/graduation">
                <h1>
                  0<span>3</span>
                </h1>
                <h2>
                  E<span>ducation</span>
                </h2>
                <p>
                  <span>Schooling at-</span> <br />
                </p>
                <ul>
                  <li>
                    <span>RPVV Paschim Vihar</span> - 12th Boards with 90.2%
                  </li>
                  <li>
                    <span>------------ </span> - ---------------{" "}
                  </li>
                  <li>
                    <span>B-4 Paschim Vihar</span> - 10th Boards with 86%
                  </li>
                </ul>
              </Link>
            </div>
            <div
              className="about__details"
              data-aos="fade-down"
              data-aos-offset="-180"
              data-aos-delay="700"
              data-aos-once="true"
            >
              <Link to="/about/graduation">
                <h1>
                  0<span>4</span>
                </h1>
                <h2>
                  E<span>ngineering</span>
                </h2>
                <p>
                  <span>Netaji Subhas University Of Technology.</span>
                  <br />I am persuing Electrical Engineering from this
                  college(passing year 2025).From first year, I had a great bend
                  towards tech side and coding really energies me and craved me
                  to improve more and more ,so this college gave me amazing
                  peers to discuss and improve myself.
                </p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
